var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Informe LOPD",
        visible: _vm.showing,
        width: "45rem",
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.showing = $event
        },
        close: _vm.onCloseDialog,
      },
    },
    [
      _vm.completed
        ? _c("Reports-SuccessMessageWithHistoricalLink", {
            attrs: { reportName: "LOPD" },
          })
        : _c("div", [
            _c(
              "p",
              { staticClass: "description" },
              [
                _vm._v("Una vez generado el informe podrás descargarlo en "),
                _c(
                  "router-link",
                  {
                    staticClass: "el-link",
                    attrs: { to: _vm.historicalLocation },
                  },
                  [_vm._v("la página de históricos")]
                ),
                _vm._v("."),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "buttons" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", round: "", loading: _vm.loading },
                    on: { click: _vm.onClickGenerate },
                  },
                  [_vm._v("Generar informe LOPD")]
                ),
              ],
              1
            ),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }